import { ChatRoom } from 'models/ChatRoom';
import { setChatRoomAsActive } from 'react/redux/actions/chat';
import { dockChatOpened } from 'react/redux/actions/dockChat';
import { loadStartupSections } from 'app/StartupEventManager';
import { privateChatMessageHolder } from 'components/PrivateChatMessageHolder';

// Opens the dock's chat sheet (react/dock/chat/DockChatSheet). A room it shows
// is the selected room, as in the netplay Chat view, so reading it there marks
// it read and new messages in it aren't counted unread.

let loadedSheetData = false;

// What startup leaves out off the netplay page: emotes and chat links, the
// player's ladders (the Slippi tag on their own messages), and the DM list's
// first page. Loaded once, the first time the sheet opens.
function loadSheetDataOnce() {
	if(loadedSheetData) {
		return;
	}
	loadedSheetData = true;
	loadStartupSections(['chat_text', 'my_ladders']).catch((error) => console.error('[dock chat] emotes and ladders failed to load', error));
	privateChatMessageHolder.retrievePrivateMessages(1);
}

// With nothing open before: the match, else the selected room, the first room, the first DM.
function firstConversation(state) {
	const match = state.matchmaking && state.matchmaking.currentMatch;
	if(match) {
		return { kind: 'match', id: match.id };
	}
	const room = ChatRoom.getActiveMainChat() || ChatRoom.activeChats.values().next().value;
	if(room) {
		return { kind: 'room', id: room.id };
	}
	const [firstDm] = privateChatMessageHolder.sortedChatsById();
	return firstDm ? { kind: 'dm', id: firstDm[1].player.id } : null;
}

/** conversation: { kind: 'room' | 'dm' | 'match', id }; none reopens the last one. */
export default function openDockChat({ conversation = null, messageId = null } = {}) {
	return (dispatch, getState) => {
		loadSheetDataOnce();
		const target = conversation || getState().dockChat.conversation || firstConversation(getState());
		if(target && target.kind === 'room') {
			const room = ChatRoom.activeChats.get(Number(target.id));
			if(room) {
				dispatch(setChatRoomAsActive(room));
			}
		}
		dispatch(dockChatOpened({ conversation: target, messageId }));
	};
}

/** Message on a profile card, from any page: the DM opens in the sheet, created when new. */
export function openDockDirectMessage(player) {
	return (dispatch) => {
		privateChatMessageHolder.openPrivateChat(player);
		dispatch(openDockChat({ conversation: { kind: 'dm', id: player.id } }));
	};
}
